export const DEFAULT_PAGE_SIZE = 10;
export const GWI_DEFAULT_TABLE_PAGE_SIZE = 'gwi-default-table-page-size';